import styled from 'styled-components'

import { Card as DefaultCard } from '@/components/business/visitor-parking/card'
import { Icon as DefaultIcon } from '@/components/ui/icon'

export const Title = styled.h1(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '3.6rem',
  fontWeight: 600,
  marginBottom: theme.space['24'],
  textAlign: 'center',
}))

export const Card = styled(DefaultCard)({
  alignItems: 'center',
  justifyContent: 'center',
})

export const Icon = styled(DefaultIcon)(({ theme }) => ({
  color: theme.colors.visitorParkingSuccessText,
  marginBottom: theme.space['10'],
}))

export const SuccessInfo = styled.p(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '2rem',
  fontWeight: 600,
  textAlign: 'center',
}))

export const SuccessDescription = styled.p(({ theme }) => ({
  color: theme.colors.black700,
  fontSize: '1.4rem',
  fontWeight: 400,
  textAlign: 'center',
}))

export const DetailsCardContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
  marginTop: theme.space['12'],
  width: '100%',
}))

export const Separator = styled.hr(({ theme }) => ({
  backgroundColor: theme.colors.gray300,
  height: '0.1rem',
  margin: 0,
  width: '100%',
}))
